<div class="vehicle" *ngIf="vehicle" (mouseenter)="mouseenter()" (mouseleave)="mouseleave()">{{vehicle.shortName}}</div>